/**
 * This panel is displayed when a project has no automations in it.
 */
import React from 'react';

import * as S from './ZeroTriggers.styles';

export const ZeroTriggers = () => {
  return (
    <S.Panel>
      <S.Circle>
        <S.JobAutomation />
      </S.Circle>
      <S.Heading>Automate your workflows</S.Heading>
      <S.Message>
        Automate downstream actions for versioning artifacts. To create an
        automation, define trigger events and resulting actions. Actions include
        executing a webhook or launching a Weights & Biases job.
      </S.Message>
    </S.Panel>
  );
};
